import React from 'react';
import { Tabs, Button } from '@components';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const SolicitacaoResgateParcialPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = () => {
    if (location.pathname.includes('historico'))
      return 'Histórico de Pedidos de Resgate Parcial';
    if (location.pathname.includes('formulario'))
      return 'Formulário de Resgate Parcial';
    if (location.pathname.includes('informe')) return 'Informe de Rendimentos';
    return 'Formulário de Resgate Parcial';
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Resgate Parcial</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2">
        Requerimento de Resgate Parcial
      </h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <Tabs active={activeTab}>
        <div
          label="Formulário de Resgate Parcial"
          onClick={() => navigate('formulario')}
          aria-hidden
        >
          <Outlet />
        </div>
        <div
          label="Histórico de Pedidos de Resgate Parcial"
          onClick={() => navigate('historico')}
          aria-hidden
        >
          <Outlet />
        </div>
        <div
          label="Informe de Rendimentos"
          onClick={() => navigate('informe')}
          aria-hidden
        >
          <Outlet />
        </div>
      </Tabs>
    </>
  );
};
